// extracted by mini-css-extract-plugin
export default {"add_btn":"style_add_btn__Yos4A"};